export class Modal {
  constructor(modalElement) {
    // Setup properties
    this.element = modalElement;

    // Setup event listeners
    document.querySelectorAll('[data-modals-open]').forEach(el => {
      if (el.dataset.modalsOpen === this.element.id) {
        el.addEventListener('click', () => this.openModal(this.element));
      }
    });
    document.querySelectorAll('[data-modals-close]').forEach(el => {
      if (el.dataset.modalsClose === this.element.id) {
        el.addEventListener('click', () => this.closeModal(this.element));
      }
    });
    document.querySelectorAll('[data-modals-toggle]').forEach(el => {
      if (el.dataset.modalsToggle === this.element.id) {
        el.addEventListener('click', () => this.toggleModal(this.element));
      }
    });
  }

  /**
   * Opens the modal
   */
  openModal() {
    this.constructor.openModal(this.element);
  }

  /**
   * Closes the modal
   * @param {*} [options]
   */
  closeModal(options) {
    this.constructor.closeModal(this.element, options);
    const youtubeIFrames = Array.from(document.querySelectorAll('.iframe-youtube-video'));
    youtubeIFrames.forEach(youtubeIFrame => {
      youtubeIFrame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  }

  /**
   * toggles the modal
   */
  toggleModal() {
    this.constructor.toggleModal(this.element);
  }

  /**
   * Shakes the modal
   */
  shakeModal() {
    this.constructor.shakeModal(this.element);
  }

  /**
   * gets the coresponding HTMLElement of a model
   * @param  {string | HTMLElement} targetModal - The modal or its ID or a querySelector
   * @return {HTMLElement}
   */
  static getModalElement(targetModal) {
    if (typeof targetModal === 'string') {
      targetModal = document.getElementById(targetModal);
      if (!targetModal) {
        targetModal = document.querySelector(targetModal);
        if (!targetModal) {
          throw new Error(`Failed to find an element using the selector '${targetModal}'.`);
        }
      }
    } else if (!(targetModal instanceof HTMLElement)) {
      throw new Error(`Invalid HTMLElement provided: '${targetModal ? targetModal.tagName : targetModal}'.`);
    }
    return targetModal;
  }

  /**
   * opens a modal
   * @param  {string | HTMLElement} targetModal - The modal or its ID or a querySelector
   * @return {void}
   */
  static openModal(targetModal) {
    let modal = this.getModalElement(targetModal);
    modal.classList.add('is-opened');
    modal.setAttribute('aria-hidden', false);
  }

  /**
   * closes a modal
   * @param  {string | HTMLElement} targetModal - The modal or its ID or a querySelector
   * @param  {object} options - Set options for closing
   * @return {void}
   */
  static closeModal(targetModal, options) {
    const modal = this.getModalElement(targetModal);
    const modalContainer = modal.querySelector('.modal-container');
    if (options) {
      if (options.success) {
        modal.classList.add('is-success');
      }
    }
    setTimeout(() => {
      modal.setAttribute('aria-hidden', true);
    }, 50);
    modal.addEventListener(
      'transitionend',
      function handler(event) {
        if (event.srcElement === modalContainer) {
          modal.classList.remove('is-opened');
          modal.classList.remove('is-success');
          modal.removeEventListener('transitionend', handler, false);
        }
      },
      false
    );
  }

  /**
   * toggles a modal
   * @param  {string | HTMLElement} targetModal - The modal or its ID or a querySelector
   * @return {void}
   */
  static toggleModal(targetModal) {
    let modal = this.getModalElement(targetModal);
    if (modal.classList.includes('is-opened')) {
      Modal.closeModal(modal);
    } else {
      Modal.openModal(modal);
    }
  }

  /**
   * shakes a modal
   * @param  {string | HTMLElement} targetModal - The modal or its ID or a querySelector
   * @return {void}
   */
  static shakeModal(targetModal) {
    let modal = this.getModalElement(targetModal);
    modal.classList.add('is-shaking');
    modal.addEventListener(
      'animationend',
      function handler() {
        modal.classList.remove('is-shaking');
        modal.removeEventListener('animationend', handler, false);
      },
      false
    );
  }
}

// Setup Modals

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.modal').forEach(el => new Modal(el));
});
